export const REPORT_TYPES = {
    xct1: {
        id: 'xct1',
        label: 'XCT1',
        family: 'normative',
        inputModality: 'hrpqct',
        inputShape: 'site',
        datasetRequired: true,
        grouped: true,
        longitudinal: true,
        creditType: 'hrpqct',
        viewer: 'normative',
        exporter: 'hrpqct',
        processor: 'hrpqct-normative',
        colour: 'xct1',
    },
    xct2: {
        id: 'xct2',
        label: 'XCT2',
        family: 'normative',
        inputModality: 'hrpqct',
        inputShape: 'site',
        datasetRequired: true,
        grouped: true,
        longitudinal: true,
        creditType: 'hrpqct',
        viewer: 'normative',
        exporter: 'hrpqct',
        processor: 'hrpqct-normative',
        colour: 'xct2',
    },
    dxa: {
        id: 'dxa',
        label: 'DXA',
        family: 'normative',
        inputModality: 'dxa',
        inputShape: 'flat',
        datasetRequired: true,
        grouped: true,
        longitudinal: false,
        creditType: 'dxa',
        viewer: 'normative',
        exporter: 'flat-normative',
        processor: 'flat-normative',
        colour: 'dxa',
    },
    ct: {
        id: 'ct',
        label: 'CT',
        family: 'normative',
        inputModality: 'ct',
        inputShape: 'flat',
        datasetRequired: true,
        grouped: true,
        longitudinal: true,
        creditType: 'ct',
        viewer: 'normative',
        exporter: 'flat-normative',
        processor: 'flat-normative',
        colour: 'ct',
    },
    ufrac: {
        id: 'ufrac',
        label: 'µFRAC',
        family: 'computed',
        inputModality: 'hrpqct',
        inputShape: 'paired',
        datasetRequired: false,
        grouped: false,
        longitudinal: false,
        creditType: 'ufrac',
        viewer: 'ufrac',
        exporter: 'ufrac',
        processor: 'ufrac',
        colour: 'ufrac',
    },
    phenotype: {
        id: 'phenotype',
        label: 'Phenotype',
        family: 'computed',
        inputModality: 'hrpqct',
        inputShape: 'paired',
        datasetRequired: false,
        grouped: false,
        longitudinal: false,
        creditType: 'phenotype',
        viewer: 'phenotype',
        exporter: 'phenotype',
        processor: 'phenotype',
        colour: 'phenotype',
    },
};

export const REPORT_TYPE_IDS = Object.keys(REPORT_TYPES);
export const REPORT_TYPE_LIST = Object.values(REPORT_TYPES);
export const DATASET_REPORT_TYPE_IDS = REPORT_TYPE_LIST
    .filter((definition) => definition.datasetRequired)
    .map((definition) => definition.id);

export const getReportType = (reportType) => REPORT_TYPES[String(reportType || '').toLowerCase()] || null;
export const getReportTypeLabel = (reportType) => getReportType(reportType)?.label || String(reportType || '').charAt(0).toUpperCase() + String(reportType || '').slice(1); // Fallback should be capitalize first letter of reportType string
export const isKnownReportType = (reportType) => Boolean(getReportType(reportType));
export const isDatasetReportType = (reportType) => Boolean(getReportType(reportType)?.datasetRequired);
export const isGroupedReportType = (reportType) => Boolean(getReportType(reportType)?.grouped);
export const supportsLongitudinal = (reportType) => Boolean(getReportType(reportType)?.longitudinal);
export const isFlatNormativeReportType = (reportType) => getReportType(reportType)?.exporter === 'flat-normative';
export const getCreditType = (reportType) => getReportType(reportType)?.creditType || reportType;
